module.exports = __webpack_public_path__ + "static/media/16.073e504f.gif";